import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { OTPValidator } from "../../validators/auth.validators.js";
import { signup } from "../../services/auth.service.js";
import AppError from "../../utils/AppError.js";
import getMessage from "../../utils/getMessage.js";
import "../../styles/auth/auth.css";
import "../../styles/auth/verifyOtp.css";
import ErrorText from "../../components/auth/ErrorText.jsx";
import OtpInput from "../../components/otp/OtpInput.jsx";
import ResendOtpButton from "../../components/otp/ResendOtpButton.jsx";
import AuthSubmitButton from "../../components/auth/AuthSubmitButton.jsx";

const VerifyOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const [verifying, setVerifying] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState(null);
  const { email, password, firstName, lastName } = location.state || {};

  useEffect(() => {
    if (!email || !password || !firstName || !lastName) {
      navigate("/signup", { replace: true });
    }
  }, [email, password, firstName, lastName, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setVerifying(true);
    const otpValue = otp.join("");
    try {
      OTPValidator(otpValue);
      await signup({ email, password, firstName, lastName, otp: otpValue });
      navigate("/home", { replace: true });
    } catch (error) {
      if (error instanceof AppError) {
        setError(error.message);
      } else {
        setError(getMessage("common", "error"));
      }
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="outer">
      <h1 className="auth-heading">Verify OTP</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <ErrorText error={error} />

        <OtpInput
          otp={otp}
          setOtp={setOtp}
          inputsRef={inputsRef}
          verifying={verifying}
          resending={resending}
        />
        <ResendOtpButton
          email={email}
          resending={resending}
          verifying={verifying}
          setError={setError}
          setResending={setResending}
          setOtp={setOtp}
          inputsRef={inputsRef}
          type="signup"
        />
        <AuthSubmitButton
          resending={resending}
          verifying={verifying}
          text="VERIFY"
          disabledText="Verifying..."
        />
      </form>
    </div>
  );
};

export default VerifyOTP;
